


















































































































































































import Vue from 'vue'
import Vuex from 'vuex'
import VueHead from 'vue-head'
import { ParsedQuery } from 'query-string'
import ScrollBooster from 'scrollbooster'
import * as scroll from 'scroll'
import Cookies from 'js-cookie'
import * as types from '@/store/modules/play/types'
import settings from '@/settings'
import SoundKey from '@/components/play/SoundKey.vue'
import UserRecordedKey from '@/components/play/UserRecordedKey.vue'
import Track from '@/components/play/Track.vue'
import TrackStart from '@/components/play/TrackStart.vue'
import Countdown from '@/components/play/Countdown.vue'
import ComposeButton from '@/components/play/ComposeButton.vue'
import PlayButton from '@/components/play/PlayButton.vue'
import StopButton from '@/components/play/StopButton.vue'
import ResetButton from '@/components/play/ResetButton.vue'
import UndoButton from '@/components/play/UndoButton.vue'
import UserRecord from '@/components/play/record/UserRecord.vue'
import UserRecordButton from '@/components/play/UserRecordButton.vue'
import Tutorial from '@/components/play/tutorial/Tutorial.vue'
import Config from '@/components/play/Config.vue'
import DebugAudioContext from '@/components/play/DebugAudioContext.vue'
import DebugScoreUrl from '@/components/play/DebugScoreUrl.vue'
import * as audioUtil from '@/utils/audio'
import * as timeUtil from '@/utils/time'
import * as scoreUtil from '@/utils/score'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ease = require('ease-component')

Vue.use(Vuex)
Vue.use(VueHead)

interface State {
  // audioContextStartAt: number;  // 収録、再生時のAudioContextの時間（インスタンス生成直後は自動で動いていることがある）
  currentTime: {
    animationStart: number; // 再生時間のスロットル用
    sec: number;  // 秒
    requestId: number;  // requestAnimationFrameのID
  };
  sb: ScrollBooster | null; // scroll boosterのインスタンス
  isUserRecording: boolean; // 収録モード
  effectShortcutKeys: types.EffectShortcutKey[];
  headerHeight: number; // ヘッダーの高さ
  trackHeight: number;  // トラックの高さ
  countdownTimerId: number; // カウントダウン時のタイマー
  loading: {
    isDelayed: boolean; // ローディング表示のための遅延
  };
  tutorial: {
    isPlaying: boolean; // チュートリアル表示中
    enterDelayTimer: number; // 表示時の遅延表示用
  };
  config: {
    isPlaying: boolean; // 設定モーダル表示中
  };
  env: {
    // レスポンシブ対応のための変数
    deviceWidth: 'small' | 'medium';
    isIphone: boolean; // iPhone
    isIpad: boolean;  // iPad
  };
}

export default Vue.extend({
  name: 'Play',

  head: {
    title: {
      inner: '作曲する',
      separator: '｜',
      complement: 'ミュージックメーカー｜おだきゅうキッズ｜小田急電鉄',
    },
  },

  components: {
    'sound-key': SoundKey,
    'user-recorded-key': UserRecordedKey,
    'audio-track': Track,
    'audio-track-start': TrackStart,
    countdown: Countdown,
    'compose-button': ComposeButton,
    'play-button': PlayButton,
    'stop-button': StopButton,
    'reset-button': ResetButton,
    'undo-button': UndoButton,
    'user-record-button': UserRecordButton,
    'user-record': UserRecord,
    tutorial: Tutorial,
    config: Config,
    'debug-score-url': DebugScoreUrl,
    'debug-audio-context': DebugAudioContext,
  },

  data (): State {
    return {
      currentTime: {
        animationStart: 0,
        sec: 0,
        requestId: NaN,
      },
      sb: null,
      isUserRecording: false,
      effectShortcutKeys: [
        { code: 'KeyQ', label: 'Q' },
        { code: 'KeyW', label: 'W' },
        { code: 'KeyE', label: 'E' },
        { code: 'KeyR', label: 'R' },
        { code: 'KeyT', label: 'T' },
        { code: 'KeyY', label: 'Y' },
        { code: 'KeyU', label: 'U' },
        { code: 'KeyI', label: 'I' },
        { code: 'KeyA', label: 'A' },
        { code: 'KeyS', label: 'S' },
        { code: 'KeyD', label: 'D' },
        { code: 'KeyF', label: 'F' },
        { code: 'KeyG', label: 'G' },
        { code: 'KeyH', label: 'H' },
        { code: 'KeyJ', label: 'J' },
        { code: 'KeyK', label: 'K' },
      ],
      headerHeight: 40,
      trackHeight: 100,
      countdownTimerId: NaN,
      loading: {
        isDelayed: false,
      },
      tutorial: {
        isPlaying: false,
        enterDelayTimer: NaN,
      },
      config: {
        isPlaying: false,
      },
      env: {
        deviceWidth: 'small',
        isIphone: Boolean(navigator.userAgent.match(/(iPhone|iPod)/i)),
        isIpad: Boolean(navigator.userAgent.match(/iPad|macintosh/i)) && 'ontouchend' in document,  // iPad Safariには"iPad"は含まれていない（chromeだけ）
      },
    }
  },

  mounted () {
    // TODO AudioContextが存在しない場合はトップに戻す（遊べないので）
    console.log('audioContext', this.audioContext)

    if (!this.audioContext) {
      this.$router.replace({
        path: '/',
      })
    }

    // 音をAudioBufferに変換
    this.createAudioBuffer()

    // ページが非表示されたら停止
    // TODO スマホ、タブレットのみ？
    document.addEventListener('visibilitychange', this.onVisibilityChanged)

    // 番組表をドラッグでスクロールする
    this.sb = new ScrollBooster({
      content: this.$refs.timelineInner,
      viewport: this.$refs.timelineScroller,
      scrollMode: 'native',
      direction: 'horizontal',
      pointerMode: 'mouse',
      friction: 0.25,
    })

    // クエリーにスコアの情報があれば復元
    if (this.query.score) {
      this.restoreScoreFromQuery(this.query.score)
    }

    // メディアクエリーの検知
    const mediaQueryList = window.matchMedia('(max-width: 751px)')
    mediaQueryList.addListener(this.onChangeBreakPoint)
    this.detectDeviceByBreakPoint(mediaQueryList)

    // デバイスごとの設定
    this.deviceSettings()

    // ローディング表示するために一定時間待つ
    // TODO ロード未完了のときだけにしたい
    setTimeout(() => {
      this.loading.isDelayed = true
    }, 2000)
  },

  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.onVisibilityChanged)

    // 再生、録音、収録モードを停止
    this.stopMusic()
    this.stopComposeCountdown()
    this.dismissUserRecord()
  },

  computed: {
    /**
     * スコアに配置された音
     */
    score (): types.SoundOnScore[] {
      return this.$store.state[types.moduleName].score
    },

    /**
     * 再生中の音があるか
     */
    hasPlayingBufferSource (): boolean {
      return this.$store.getters[`${types.moduleName}/${types.Getter.HAS_PLAYING_BUFFER_SOURCE}`]
    },

    /**
     * AudioContext
     */
    audioContext (): AudioContext | null {
      return this.$store.state[types.moduleName].audioContext
    },

    /**
     * 再生開始時点のAudioContextの時間
     */
    audioContextStartAt (): number {
      return this.$store.state[types.moduleName].audioContextStartAt
    },

    /**
     * 音の一覧
     */
    soundSources (): types.SoundSrc[] {
      return this.$store.getters[`${types.moduleName}/${types.Getter.SOUND_SOURCES}`]
    },

    /**
     * 音のキー一覧
     */
    keys (): types.SoundSrc {
      return this.$store.state[types.moduleName].soundSources.effect
    },

    /**
     * ロード完了
     */
    isLoaded (): boolean {
      // すべてのAudioBufferを読み込んだか

      // ユーザー録音以外の音
      const seAndBgm = this.soundSources.filter((src: types.SoundSrc) => {
        return src.soundId !== 'user-recorded'
      })

      const loadAudioBufferList = seAndBgm.map((src: types.SoundSrc) => {
        return src.audioBuffer !== undefined
      })

      return loadAudioBufferList.length === seAndBgm.length && this.duration > 0 && this.loading.isDelayed
    },

    /**
     * 再生モード
     */
    playMode (): types.PlayMode {
      return this.$store.state[types.moduleName].playMode
    },

    /**
     * 再生中か
     */
    isPlaying (): boolean {
      return this.$store.state[types.moduleName].isPlaying
    },

    /**
     * 収録前のカウントダウン中か
     */
    isCountingDown (): boolean {
      return this.$store.state[types.moduleName].isCountingDown
    },

    /**
     * 録音中か
     */
    isRecording (): boolean {
      return this.playMode === 'record'
    },

    /**
     * BGMの再生時間
     */
    duration (): number {
      return this.$store.state[types.moduleName].duration
    },

    /**
     * 1秒あたりのトラックの幅
     */
    pxPerSec (): number {
      return this.$store.state[types.moduleName].trackWidthPerSecond
    },

    /**
     * 音ズレ調整の値（秒換算）
     */
    audioLatencyAdjustSec (): number {
      return this.$store.state[types.moduleName].audioLatencyAdjust / 1000
    },

    /**
     * クエリー文字列
     */
    query (): ParsedQuery {
      return this.$store.state.query
    },

    /**
     * 削除された音
     */
    removedScore (): types.SoundOnScore[] {
      return this.$store.state[types.moduleName].removedScore
    },

    /**
     * デバッグモードか
     */
    isDebugMode (): boolean {
      // odakyu.jpではデバッグモードを無効
      return Boolean(this.query.debug) && document.location.host.indexOf('odakyu.jp') === -1
    },
  },

  methods: {
    /**
     * チュートリアルを開始
     */
    startTutorial () {
      const isTutorialSkipByCookie = Boolean(Number(Cookies.get(settings.cookieName.isTutorialSkip)))
      const isTutorialSkipByQuery = Boolean(Number(this.$route.query['skip-tutorial']))

      if (!isTutorialSkipByCookie && !isTutorialSkipByQuery) {
        if (!isNaN(this.tutorial.enterDelayTimer)) {
          clearTimeout(this.tutorial.enterDelayTimer)
        }

        // 少し間を置いてから表示
        this.tutorial.enterDelayTimer = window.setTimeout(() => {
          this.tutorial.isPlaying = true
        }, 500)
      }
    },

    /**
     * 音をAudioBufferに変換しておく
     */
    createAudioBuffer () {
      this.soundSources.forEach((item: types.SoundSrc | types.UserRecordedSoundSrc) => {
        this.$store.dispatch(`${types.moduleName}/${types.Action.FETCH_AUDIO_FILE}`, item.src)
      })
    },

    /**
     * 収録
     */
    recordMusic () {
      this.start('record')
    },

    /**
     * 再生
     */
    playMusic () {
      this.start('play')
    },

    /**
     * 再生停止
     */
    stopMusic () {
      this.stop()

      // スクロール位置を戦闘へ
      this.scrollLeftOfTimeline(0, true)

      // 収録前のカウントダウン中ならカウントダウンを停止
      this.stopComposeCountdown()

      // // タイマーを戻しておく
      // this.currentTime.sec = 0
    },

    /**
     * 演奏開始
     * @param playMode
     */
    start (playMode: types.PlayMode) {
      // AudioContextを生成しておく
      this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_CONTEXT.CREATE}`)

      audioUtil.playSilent(this.audioContext)

      // 再生モードの設定（収録 or 再生）
      this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_PLAY_MODE}`, playMode)

      // 頭出し
      this.scrollLeftOfTimeline(0)

      // 録音時はカウントダウンしてスタート
      const needCountDown = playMode === 'record'
      if (needCountDown) {
        this.$store.commit(`${types.moduleName}/${types.Mutation.COUNTDOWN.START}`)
      }

      // ユーザーアクション連動にならないけど再生できる？
      this.countdownTimerId = window.setTimeout(() => {
        this.countdownTimerId = NaN

        this.$store.commit(`${types.moduleName}/${types.Mutation.COUNTDOWN.STOP}`)

        // 開始
        this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_PLAY_STATUS}`, true)

        // 収録、再生時のAudioContextの時間を保持（インスタンス生成直後や収録時のカウントダウン後は進んでいる）
        // 開始を0として計算するため
        if (this.audioContext) {
          this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_CONTEXT.START_AT}`, this.audioContext.currentTime)
        }

        // デフォルトでBGMを登録
        this.playAudio('bgm', 0)

        // 登録されている音を登録
        this.score.forEach((item: types.SoundOnScore) => {
          this.playAudio(item.soundId, item.when)
        })
      }, needCountDown ? 3000 : 0)
    },

    /**
     * 停止
     */
    stop () {
      // // Android（遅延のある端末？）で再生時に、一つ前の音がノイズとして残るようなので一旦トリ
      // if (this.audioContext.state === 'running') {
      //   this.audioContext.close()
      // }

      // 再生中の音をすべてクリアする
      this.$store.commit(`${types.moduleName}/${types.Mutation.PLAYING_BUFFER_SOURCE.CLEAR}`)

      // 停止
      this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_PLAY_STATUS}`, false)

      // 収録モードを停止
      this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_PLAY_MODE}`, 'play')
    },

    /**
     * 収録前のカウントダウンを停止
     */
    stopComposeCountdown () {
      this.$store.commit(`${types.moduleName}/${types.Mutation.COUNTDOWN.STOP}`)

      // タイマーを停止
      if (!isNaN(this.countdownTimerId)) {
        clearTimeout(this.countdownTimerId)
        this.countdownTimerId = NaN
      }
    },

    /**
     * 音を再生
     * @param soundId 音ID
     * @param when 再生開始秒
     */
    playAudio (soundId: string, when = 0) {
      // 音IDからSoundBufferを取得
      const source: types.SoundSrc | types.UserRecordedSoundSrc | null = this.$store.getters[`${types.moduleName}/${types.Getter.SOUND_SOURCE}`](soundId)

      if (source && source.audioBuffer) {
        const audioBufferSourceNode = audioUtil.playAudio(this.audioContext, source.audioBuffer, when)
        const playingBufferSourceId = audioUtil.createPlayingAudioBufferId()  // 再生中リストで管理するためのIDを発行する

        // IE11ではplayAudioの戻り値がnullになるので、if文で弾く
        if (audioBufferSourceNode) {
          // 再生中リストに追加する
          const payload: types.PlayingBufferSource = {
            id: playingBufferSourceId,
            soundId: source.soundId,
            audioBufferSourceNode: audioBufferSourceNode,
          }
          this.$store.commit(`${types.moduleName}/${types.Mutation.PLAYING_BUFFER_SOURCE.ADD}`, payload)

          // 音の再生終了で再生中リストから削除
          audioBufferSourceNode.addEventListener('ended', () => {
            // TODO 不要？
            this.$store.commit(`${types.moduleName}/${types.Mutation.PLAYING_BUFFER_SOURCE.REMOVE}`, playingBufferSourceId)

            console.log('ended', playingBufferSourceId)
            if (soundId === 'bgm') {
              // BGM再生終了で停止。収録モードもクリア
              this.stop()
            }
          })
        }
      } else {
        // ここにくるのは実装エラーのはず
        console.error('soundIdが間違っているかAudioBufferが未生成', source)
      }
    },

    /**
     * 現在時間の表示を開始
     */
    startCurrentTimeDisplay () {
      this.requestId = window.requestAnimationFrame(this.updateCurrentTime)
    },

    /**
     * 現在時間の表示を停止
     */
    stopCurrentTimeDisplay () {
      window.cancelAnimationFrame(this.requestId)
      this.currentTime.sec = 0
    },

    /**
     * AudioContextの再生時間を表示
     * @param timestamp
     */
    updateCurrentTime (timestamp: number) {
      const progress = timestamp - this.currentTime.animationStart  // 進捗
      this.currentTime.sec = this.audioContext.currentTime - this.audioContextStartAt

      console.log('updateCurrentTime')

      // requestAnimationFrameは間引く（スマホで実行すると端末がかなり熱くなる）
      // if (progress > 41.6) {
      if (progress > 100) {
        // 繰り返し
        this.requestId = window.requestAnimationFrame(this.updateCurrentTime)
      }
    },

    /**
     * 停止ボタンが押された
     */
    onStopClicked () {
      this.stopMusic()
    },

    /**
     * 収録ボタンが押された
     */
    onComposeClicked () {
      // トグルで収録と停止を切り替え
      if (this.isRecording) {
        this.stopMusic()
      } else {
        this.recordMusic()
      }
    },

    /**
     * ユーザーの声を収録開始
     */
    startUserRecord () {
      // 再生中の音を停止
      // iPhoneでマイクオンと同時に音が鳴っているとひどい音になるので先に消しておく
      this.stop()

      this.isUserRecording = true
    },

    /**
     * ページが非表示された
     * @param e
     */
    onVisibilityChanged (e: Event) {
      const document = e.target as Document
      if (document.visibilityState === 'hidden') {
        this.stop()
      }
    },

    /**
     * タイムラインのスクロールを設定する
     * @param left
     * @param isSmooth イージングするか
     */
    scrollLeftOfTimeline (left: number, isSmooth = false) {
      const scroller = this.$refs.timelineScroller
      if (scroller) {
        if (!isSmooth) {
          scroller.scrollLeft = left
        } else {
          scroll.left(scroller, left, {
            duration: 350,
            ease: ease.outQuart,
          })
        }
      }
    },

    /**
     * 頭出し
     */
    backward () {
      this.scrollLeftOfTimeline(0, true)
      this.currentTime.sec = 0
    },

    /**
     * チュートリアルを終了
     */
    dismissTutorial () {
      this.tutorial.isPlaying = false
    },

    /**
     * 設定を終了
     */
    dismissConfig () {
      this.config.isPlaying = false
    },

    /**
     * 録音を終了
     */
    dismissUserRecord () {
      this.isUserRecording = false
    },

    /**
     * クエリー文字列からスコアを復元する
     * @param score
     */
    restoreScoreFromQuery (score: string) {
      const decodedScore = scoreUtil.queryToScore(score)
      if (decodedScore) {
        this.$store.commit(`${types.moduleName}/${types.Mutation.DEBUG.SCORE.RESTORE}`, decodedScore)
      }
    },

    /**
     * ブレイクポイントを通過した
     */
    onChangeBreakPoint (e: MediaQueryListEvent) {
      this.detectDeviceByBreakPoint(e)
    },

    /**
     * ブレイクポイントからデバイスを判別する
     * @param mq メディアクエリー or メディアクエリーイベント
     */
    detectDeviceByBreakPoint (mq: MediaQueryList | MediaQueryListEvent) {
      this.env.deviceWidth = mq.matches ? 'small' : 'medium'
    },

    /**
     * デバイスごとの設定
     */
    deviceSettings () {
      // 画面幅によってトラックの幅、高さを変える
      if (this.env.deviceWidth === 'small') {
        // スマホ
        this.$store.commit(`${types.moduleName}/${types.Mutation.TRACK_WIDTH_PER_SECOND.SM}`)

        // トラックの高さは画面の高さからその他の要素の高さを引いた値にする
        // ヘッダー: 40px
        // 再生・停止、メニューボタンなど: 82px
        // タイムラインのスクロールバーの高さ: 8px
        // キー: 300px
        // 余白: 10px
        const destTrackHeight = Math.round((window.innerHeight - 40 - 82 - 8 - 300 - 10) / 2)
        this.trackHeight = Math.min(100, destTrackHeight)

        if (destTrackHeight > 100) {
          // 画面が余った分、ヘッダーをある程度太くする
          const stretch = (destTrackHeight - 100) * 2 // 伸びしろ
          this.headerHeight = 40 + Math.min(stretch, 30)
        } else {
          // デフォルトのサイズ
          this.headerHeight = 40
        }

        // TODO 画面が変わったときに高さを設定し直す？
      } else {
        // タブレット、デスクトップ
        this.$store.commit(`${types.moduleName}/${types.Mutation.TRACK_WIDTH_PER_SECOND.MD}`)
        this.trackHeight = 130
        this.headerHeight = 70
      }
    },
  },

  // watchはアロー関数不可
  watch: {
    isLoaded: function (val: boolean) {
      // ローディング完了でチュートリアルを開始（必要な場合）
      if (val) {
        this.startTutorial()
      }
    },

    // 音の再生停止でaudioContextを解放する
    // 都合悪いタイミング（龍録のカウントダウン時など）でcloseすると再生できなくなる
    // 消すとパフォーマンスが心配ではある
    // hasPlayingBufferSource: function (value: boolean) {
    //   console.log('hasPlayingBufferSource', this.audioContext.state === 'running')
    //   // 再生中の音なし＆AudioContextが実行中なら停止。ただし収録カウントダウン中は除く。
    //   if (!value && this.audioContext.state === 'running' && !this.isCountingDown) {
    //     console.log(this.audioContext)
    //     if (this.audioContext.state === 'running') {
    //       this.audioContext.close()
    //         .catch((e: Error) => {
    //           console.error(e)
    //         })
    //     }
    //   }
    // },

    isPlaying: function (value: boolean) {
      // 再生されたらAudioContextの現在時間を更新しつづける
      // AudioContext.currentTimeはリアクティブにしていないため
      if (value) {
        this.startCurrentTimeDisplay()
      } else {
        this.stopCurrentTimeDisplay()
      }
    },

    /**
     * 再生中はスクロールを同期する
     */
    'currentTime.sec': function (sec: number) {
      if (this.isPlaying) {
        // TODO 音ズレ調整されていたら、その秒数分遅らせる
        this.scrollLeftOfTimeline((sec - this.audioLatencyAdjustSec) * this.pxPerSec) // 秒 * 1秒あたりの幅
      }
    },

    /**
     * 再生時間が変更
     */
    duration: function () {
      // scroll boosterの幅を更新
      Vue.nextTick(() => {
        this.sb.updateMetrics()
      })
    },

    /**
     * 音が一つ削除された（リセットは含まない）
     */
    removedScore: function (score: types.SoundOnScore[]) {
      const latestRemoved = score[score.length - 1]
      const start = window.innerWidth * 0.34 // 音の配置開始位置。cssに設定されているので合わせる。
      console.log('latestRemoved', latestRemoved, latestRemoved.when * this.pxPerSec)

      // 削除された音の配置位置
      // TODO これがページ中央になるように
      const left = latestRemoved.when * this.pxPerSec
      this.scrollLeftOfTimeline(Math.round((start + left) - window.innerWidth / 2), true)
    },

    /**
     * デバイスの幅が変わった
     */
    'env.deviceWidth': function (val: 'small' | 'medium') {
      this.deviceSettings()
    },
  },

  filters: {
    /**
     * 秒→hh:mm:ss.ss
     * @param sec 秒
     */
    timeFormat (sec: number) {
      return timeUtil.secToTime(sec)
    },
  },
})
